<template>
    <div class="Size_text_div">
           <div class="Size_text">
                
                 <h1>尺码解读</h1>
                 <h2>合体的衣服，必须有合适的尺码。选择合适的尺码，常常让人无从下手。收到尺码不合适的商品既影响购物的愉悦感，退换货又耽误了时间。根据以往客户购买的经验，我们为您总结了一些选择尺码的注意事项，供您参考。</h2>
                 <p>1.为什么选择的尺码会不合适？</p>
                 <p>在选择尺码的时候会陷入两个误区：</p>
                 <p>（1）参考身高、体重来选择尺码；</p>
                 <p>（2）习惯性选择平时的尺码，比如S/M/L码。</p>
                 <p>由于品牌风格不同，商品款式不同，商品标准尺码会有一定的差别。选择合适的尺码，需要服装与人体尺寸相匹配。一般来说，上衣和连衣裙尺码的第一参考信息是胸围，其次是肩宽；下装尺码的第一参考信息是腰围，其次是臀围；鞋类商品按照脚长选择合适的鞋内长，内衣内裤根据平铺测量，增加一定的弹性范围来选择。</p>
                 <p>2.挑选商品时不知道应该选择哪种尺寸，有什么推荐呢？</p>
                 <p>因为每个品牌的标准尺码不同，每款商品页面上都会有专业人员手工测量的尺码表，以及测量方法。需要根据尺码表来选择哦~
例如，您按照页面上的测量方法，测量到平常穿着的裤子腰围是76cm，您想要购买的商品腰围S号对应74cm，M号对应78cm，则建议您选择78cm的M号哦~</p>
                 <p>3.为什么网页上显示的尺码跟我收到货的时候尺码是不一样的？
商品包装上的尺寸只是一个范围，会有些许的误差；网页上的尺码都是库房人员手动测量的，尺寸会更为准确。</p>
                  <p>4.我自己测量了肩宽、胸围，怎么选择的尺码还是小了？
一般来说，服装尺寸比人体实际测量尺寸要略大一些。女士在选购服装时，上衣胸围大5-10cm，肩宽大1-3cm较为合身；男士在选购服装时，上衣胸围大10-15cm，肩宽大1-3cm较为合身，下装腰围大2-4cm，臀围不小于人体尺寸较为合身。冬装外套类服装一般略大于上述参考值。（以上信息仅为建议，具体情况视季节、个人习惯、商品材质、服装版型等选择。）</p>
                  <p> <span>温馨提示：</span>最佳办法可以将您平时穿着最合身的同类衣裤平铺测量。按照上衣肩宽、胸围，下装腰围、臀围等信息，进行比照，选择尺码表中，与您需要的尺码最合适的尺寸即可哦~</p>
           </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>

<style>
  .Size_text_div{
        
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 50px;
  }
  .Size_text{
        border: 1px dotted #888;
        width: 80%;
        height: 100%;
        /* display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center; */
        text-align: left;
        padding: 50px;
        box-sizing: border-box;
        line-height: 30px;
  }
  .Size_text h1{
        color: rgb(218, 65, 65);
        font-size: 20px;   
        text-align: center;   
        font-weight: bold;
  }
  .Size_text span{
         color: rgb(218, 65, 65);
        font-size: 17px;   
        text-align: center;   
        font-weight: bold;
  }

  .Size_img h1{
      margin: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/SizeText.vue